<template>
    <div class="view view--edit-tile-category">
        <edit-tile-category v-bind:id="id" />
    </div>
</template>

<script>
    import editTileCategory from '../../../components/EditTileCategory.vue';

    export default {
        components: {
            editTileCategory
        },
        data: function () {
            return {
                id: parseInt(this.$route.params.category) || null
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/tiles/categories/Edit.vue